module.exports = __webpack_public_path__ + "img/phoenix_kedel_1.47762bc9.png";